import { useTranslation } from "react-i18next";
import "@/localisation/index";
import { useState, useRef, useEffect } from "react";
import { SendEmailIcon } from "@/components/Icons";
import { getUserToken } from "@/utils/userAuthenticate";
import instance from "@/axios";
import { sanitizeInput } from "@/hooks/useInputSanitization";

export default function SendTestEmail({ templateId, type }) {
    const { t } = useTranslation();
    const [showEmailInput, setShowEmailInput] = useState(false);
    const [isEmailSending, setIsEmailSending] = useState(false);
    const [testEmailAddress, setTestEmailAddress] = useState("");
    const emailInputRef = useRef(null);
    const containerRef = useRef(null);

    const sendTestEmail = async () => {
        const recipientEmail = testEmailAddress;
        if (!recipientEmail) {
            alert(t("emailTemplates.testEmailError"));
        } else {
            try {
                setIsEmailSending(true);
                const url = "/mail-template/send-test";
                const headers = { Authorization: getUserToken() };
                const body = {
                    email_id: recipientEmail,
                    id: templateId,
                    type
                };
                const res = await instance.post(url, body, { headers });
                const { success } = res.data;
                if (success) {
                    alert(t("emailTemplates.testEmailSuccess"));
                }
            } catch (error) {
                console.log('error', error.message);
            } finally {
                setIsEmailSending(false);
                setShowEmailInput(false);
            }
        }
    };

    // Close email input when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                containerRef.current && 
                !containerRef.current.contains(event.target)
            ) {
                setShowEmailInput(false);
            }
        };

        if (showEmailInput) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showEmailInput]);

    return (
        <div className="send-test-email" ref={containerRef}>
            <div 
                className="back-button" 
                onClick={() => setShowEmailInput(!showEmailInput)}
            >            
                <span className="button-text">{t("emailTemplates.sendTestEmail")}</span>
                <div className="icon-container">
                    <SendEmailIcon />
                </div>
            </div>
            {showEmailInput && (
                <div className="send-test-email__input">
                    <input
                        type="email"
                        id="test-email"
                        className="email-configuration__input"
                        placeholder={t("emailTemplates.enterTestEmail")}
                        value={testEmailAddress}
                        ref={emailInputRef}
                        onChange={(e) => setTestEmailAddress(sanitizeInput(e.target.value, "email"))}
                    />
                    <button disabled={isEmailSending} onClick={sendTestEmail}>
                        {t("emailTemplates.send")}
                    </button>
                </div>
            )}
        </div>
    );
}
